export const USER_LOGGED_IN = "USER_LOGGED_IN"; 
export const USER_LOGGED_OUT = "USER_LOGGED_OUT"; 

export const USER_REGISTERATION = "USER_REGISTERATION";

export const BOOK_CREATED = "BOOK_CREATED";
export const BOOKLIST_CREATED = "BOOKLIST_CREATED";
export const BOOKLISTS_FETCHED = "BOOKLISTS_FETCHED";
export const EDIT_BOOK_LIST_META_DATA = "EDIT_BOOK_LIST_META_DATA";
export const BOOKS_FETCHED = "BOOKS_FETCHED";
export const SEARCH_RESULT = "SEARCH_RESULT";
export const EDIT_META_DATA = "EDIT_META_DATA";
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";